class UpdateService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/api-management', params);
  }

  create(params) {
    return this.apiService.post('/api/v1/api-management', params);
  }

  remove(params) {
    return this.apiService.delete('/api/v1/api-management', params);
  }
}

export default UpdateService;
